import Vue from 'vue';
var axios = require('axios');

import { getJWTFromStorage } from '@/api/localStorage';
import { API_URL } from '@/api/config';
import { API_PSI_URL } from '@/api/config';
import { API_PRINT_URL } from '@/api/config';
import { API_MSI_URL } from '@/api/config';
import { MSI_API_AUTH } from '@/api/config';
import { API_CKYC_URL } from '@/api/config';
import { API_MSI_PORTFOLIO_URL } from '@/api/config';
import { API_MSI_PORTFOLIO_USERSUBSCRIPTION_URL } from '@/api/config';
;
var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

const ApiService = {
	init () {
		Vue.axios.defaults.baseURL = API_URL;
	},

	setHeader () {
		const token = psitoken;
		if (token) {
			axios.defaults.headers.common['Authorization'] = `Token ${token}`;
		} else {
			delete axios.defaults.headers.common['Authorization'];
		}
	},

	getOpenApi (resource, params) {
		axios.defaults.headers['Content-Type'] = 'application/json'
		return axios.get(resource, { params }).catch(error => {

		});
	},

	get (resource, params) {
		axios.defaults.headers['x-access-token'] = getJWTFromStorage('psitoken');
		return axios.get(resource, { params }).catch(error => {
			if (error.response.data.status == 401) {
				window.localStorage.removeItem('psitoken')
				window.location.reload(true)
			} else {
			}
			throw new Error(`[RWV] ApiService ${error}`);

		});
	},

	getPsi (resource, psitoken) {
		axios.defaults.headers['x-access-token'] = psitoken;
		return axios.get(`${resource}`).catch(error => {
			if (error.response.data.status == 401) {
				window.localStorage.removeItem('psitoken')
				window.location.reload(true)
			} else {
			}
			throw new Error(`[RWV] ApiService ${error}`);
		});
	},

	psiLogin (resource) {
		return axios.post(resource, null, {
			headers: {
				Authorization: 'Basic d2ViX3VzZXJfY29tcG9uZW50OlVzZXIxMjMh'
			},

		}).catch(error => {
			if (error.response.status == 401) {

				// window.localStorage.removeItem('psitoken')
				// window.location.reload(true)
			} else {
			}
		});
	},

	postPsi (resource, params) {
		return axios.post(resource, params, {
			headers: {
				Authorization: `Basic ${btoa(
					unescape(
						encodeURIComponent(
							`${getJWTFromStorage('access_token')}:` + ""
						)
					)
				)}`,
        'x-access-token': getJWTFromStorage('access_token'),
			},
		}).catch(error => {

			if (error.response.status == 401) {
				window.localStorage.removeItem('psitoken')
				window.location.reload(true)
			} else {

			}
		});
	},

	postPdfDownlaod (resource, params) {
		return axios.post(resource, params, { responseType: "blob" })
			.catch(error => {

				if (error.response.status == 401) {
					window.localStorage.removeItem('psitoken')
					window.location.reload(true)
				} else {

				}
			});
	},

	post (resource, params) {
		axios.defaults.headers['Content-Type'] ='application/json'
		return axios.post(`${resource}`, params).catch((error) => {
			if (error.response.data.status == 401) {
				window.localStorage.removeItem('psitoken');
				window.location.reload(true)
			} else {

			}
		})
	},
	update (resource, slug, params) {
		return axios.put(`${resource}/${slug}`, params).catch((error) => {
			if (error.response.data.status == 401) {
				window.localStorage.removeItem('psitoken')
				window.location.reload(true)
			} else {

			}
		})
	},

	put (resource, params) {
		return axios.put(`${resource}`, params).catch((error) => {
			if (error.response.data.status == 401) {
				window.localStorage.removeItem('psitoken')
				window.location.reload(true)
			} else {

			}
		});
	},

	delete (resource) {
		return axios.delete(resource).catch(error => {
			if (error.response.data.status == 401) {
				window.localStorage.removeItem('psitoken')
				window.location.reload(true)
			} else {

			}
			throw new Error(`[RWV] ApiService ${error}`);
		});
	},

	getUtmParams () {
		var cookies = document.cookie.split(';');
		var utmCookies = cookies.filter(item => {
			return item.indexOf("utm_") > 0;
		});
		if (utmCookies.length > 0)
			return utmCookies.toString();
		else
			return null;
	}
};

export default ApiService;

export const AuthApi = {
	login (user) {
		return ApiService.post(API_URL + 'user/auth', user)
	},

	register (user) {
		return ApiService.post(API_URL + 'user', user);
	},

	get () {
		return ApiService.get(API_URL + 'user');
	},

	put (user) {
		return ApiService.put(API_URL + 'user', user);
	},

	isUserExists (user) {
		return ApiService.post(API_URL + 'user/isexists', user);
	},

	resetPassword (resetPassObj) {
		return ApiService.put(API_URL + 'resetpassword', resetPassObj);
	},

	verifyEmail (verifyEmailObj) {
		return ApiService.post(API_URL + 'verifyemailaddress', verifyEmailObj);
	},

	loginMarketSmithIndia (userObj) {
		return ApiService.post(API_URL + 'user/msiauth', userObj);
	}
};

export const UserInfoApi = {
	getUserInfo (req) {
		return ApiService.getPsi(API_URL + 'user/', req);
	},

	updateMobileNumber (updateMobileObj) {
		return ApiService.put(API_URL + 'updateMobile/', updateMobileObj);
	},

	isUserEmailExists (email) {
		return ApiService.get(API_URL + 'user/isemailexists/' + email, {});
	},

	callBackRequest (callBackObj) {
		return ApiService.post(API_URL + 'callback/sendCallbackRequest', callBackObj);
	},

	validateReferralCode (referralCodeObj) {
		return ApiService.post(API_URL + 'user/validateReferralCode', referralCodeObj);
	},

	getUserConfig () {
		return ApiService.get(API_URL + 'user/getConfig', {});
	},

	getUserReports () {
		return ApiService.get(API_URL + 'user/reports', {});
	},

	getLastUserReport () {
		return ApiService.get(API_URL + 'user/lastreport', {});
	},

	isRegisteredBrokerUser (userObj) {
		return ApiService.get(API_URL + 'user/isRegisteredBrokerUser', userObj);
	},

	getCkycStatus (userObj) {
		return ApiService.post(API_CKYC_URL + 'checkuser', userObj);
	},

	getLegalAgreement (userObj) {
		return ApiService.get(API_URL + 'getUserLegalAgreement', userObj);
	},

	saveLegalAgreement(saveLegalObject) {
		return ApiService.post(API_URL + 'saveUserLegalAgreement', saveLegalObject);
	},



};

export const ProductsApi = {
	getProducts () {
		return ApiService.get(API_URL + 'products/active');
	}
}

export const RiskProfilerApi = {
	getRiskType (riskScore) {
		return ApiService.get(API_URL + 'getrisktype/' + riskScore, {});
	},

	getRiskProfilerInfo () {
		return ApiService.get(API_URL + 'userriskprofilerinfo', {});
	},

	getDefaultRiskProfiler () {
		return ApiService.get(API_URL + 'userriskprofilerinfo/default', {});
	},

	saveRiskProfilerInfo (params) {
		return ApiService.post(API_URL + 'userriskprofilerinfo', params);
	},

	sendRiskProfilerMail(params) {
		return ApiService.post(API_URL + 'sendriskprofilermail',params);
	}
 }

export const PromotionApi = {
	validatePromo (params) {
		return ApiService.get(API_URL + 'promotions/' + params.productId + '/' + params.promoCode  + '/validate', params);
	},

	getAllBrokerPromotion () {
		return ApiService.get(API_URL + 'promotion/brokerpromotion', {});
	},

	editBrokerPromotion (params) {
		return ApiService.get(API_URL + 'promotion/' + params.promotionId + '/' + params.userType, {});
	},

	getBrokerProduct (params) {
		return ApiService.get(API_URL + 'promotion/' + params);
	},

	upsertBrokerPromotion (params) {
		return ApiService.post(API_URL + 'promotion/upsertPromotion', params)
	}
}

export const PaymentApi = {
	generatePayUHash (params) {
		return ApiService.post(API_URL + 'paymentrequest/generatehash', params);
	},

	createPaymentRequest (params) {
		params.utmParams = ApiService.getUtmParams();
		return ApiService.post(API_URL + 'paymentrequest', params);
	},

	processPaymentRequest (params) {
		return ApiService.post(API_URL + 'subscription/process', params);
	},

	updatePaymentRequest (params) {
		return ApiService.put(API_URL + 'paymentrequest', params);
	},

	getSubscription () {
		return ApiService.get(API_URL + 'subscription', {});
	},

	getTransactions () {
		return ApiService.get(API_URL + 'transactions', {});
	},

	sendPaymentSuccessMail (paymentSuccessMailObj) {
		return ApiService.post(API_URL + 'paymentsuccess', paymentSuccessMailObj);
	},

	sendPaymentFailedMail (paymentFailedMailObj) {
		return ApiService.post(API_URL + 'paymentfail', paymentFailedMailObj);
	},
	createRzpPaymentRequest (params) {
		params.utmParams = ApiService.getUtmParams();
		return ApiService.post(API_URL + 'rzppaymentrequest', params);
	},

}

export const PsiReportsApi = {
	psilogin () {
		return ApiService.psiLogin(API_PSI_URL + 'login');
	},

	generatereport (formData) {
		return ApiService.postPsi(API_PSI_URL + 'user_portfolio_json', formData);
	},

  async StandardCharteredData(params){
  try {
    const res = await ApiService.postPsi('https://api.portfoliosmith.in/sc-report', params);
    return res;
  } catch (err) {
    console.error('generate report failed', err && err.response ? err.response.data : err);
    throw err;
  }
},


	generatelastPortfolioInsight (formData) {
		return ApiService.postPsi(API_PSI_URL + 'get_trading_analysis_total_score', formData);
	},

	autoSuggestSymbols (url) {
		return ApiService.getOpenApi(url);
	},

	downloadPdf (formData) {
		return ApiService.postPdfDownlaod(API_PRINT_URL + 'upload', formData);
	},

	getSymbolPrice (url) {
		return ApiService.getOpenApi(url);
	},

	getInstrumentId (url) {
		return ApiService.getOpenApi(url);
	},

	pdfDownloadSuccess (formData) {
		return ApiService.post(API_URL + 'user/reports', formData);
	},

	updatepdfDownloadSuccess (formData) {
		return ApiService.post(API_URL + 'user/updatereport', formData);
	},

	sendReportOverMail(formData) {
		return ApiService.post(API_URL + 'user/sendreport', formData);
	},

	updateSubscription (formData) {
		return ApiService.post(API_URL + 'user/updatesubscription', formData);
	},

	getBrokerUserHoldings (brokerToken) {
        return ApiService.post(API_URL + 'user/brokeruserholdings', brokerToken);
	},

	getBrokerToken () {
		return ApiService.get(API_URL + 'user/getBrokerToken', {});
	},

	getBrokerAdminToken (clientCode) {
		return ApiService.post(API_URL + 'user/getBrokeradminToken', {clientCode:clientCode});
	},

	getBrokerAdminUserHoldings (brokerToken) {
        return ApiService.post(API_URL + 'user/brokerAdminuserholdings', brokerToken);
	},

	validateHolidayDate (date) {
		return ApiService.post(API_URL + 'validateHolidayDate', {"inputDate": date});
	}

}

export const BrokerSubscriptionApi = {
	getBrokerTransactions (params) {
		return ApiService.post(API_URL + 'subscription/brokerSubscription', params);// brokerToken & clientCode
	},

	getBrokerAllLeads (params) {
		return ApiService.post(API_URL + 'user/getAllLeadsForBroker', params);// brokerToken & clientCode
	}
}

export const MyPortfolioListMSIApi = {
	getActivePortfolioList (params) {
		return ApiService.get(API_MSI_PORTFOLIO_URL + "getActive.json?memberId="+params.memberId+"&ms-auth="+params.msAuth, {})
	},

	getMsTransactionHistory (params) {
		return ApiService.get(API_MSI_PORTFOLIO_URL + "getUserTransactionHist.json?memberId="+params.memberId+"&startDate="+ params.startDate +"&endDate="+ params.endDate + "&portfolioId=" +params.portfolioId +"&splitAdjust=" + 1 +"&ms-auth="+params.msAuth, {})

	},

	updateMsiReportSubscription (params) {
		return ApiService.put(API_MSI_PORTFOLIO_USERSUBSCRIPTION_URL + "subscription.json?memberId="+params.memberId+"&productId=108&filePath=https://storage.googleapis.com/psi-evaluation-archive/"+params.fileName+"&comments="+params.fileName, {})
	},
}



// WEBPACK FOOTER //
// ./src/api/index.js